import { Subject } from "rxjs";

export class RegistrationStepperModel {
  componentTitles: string[] = [];
  currentComponentIndex = 0;
  numberOfSteps = 0;
  stepCompleted: () => boolean;
  beforeShowNextStep: () => Subject<boolean>;
}
